import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DonationDetailPage } from '@/features/marketPromotion/pages/DonationDetailPage';
import { donationDetailSearchSchema } from '@/features/marketPromotion/types/marketPromotion.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/market-promotion/approvals/$detailId')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.APPROVAL_VIEW),
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: donationDetailSearchSchema,
  component: function DonationDetailRoute() {
    const { detailId } = Route.useParams();
    const { from, step } = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Donation Details">
        <Suspense fallback={<PageLoader />}>
          <DonationDetailPage detailId={detailId} from={from} step={step} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
